export class AppLocalStorage implements Storage {
  private readonly storage: Storage;

  private readonly spaceName: string;

  constructor(appName: string) {
    this.spaceName = appName;
    this.storage = localStorage;
  }

  getItem(key: string): string | null {
    return this.storage?.getItem(`${this.spaceName}-${key}`) ?? null;
  }

  setItem(key: string, data: string): void {
    this.storage?.setItem(`${this.spaceName}-${key}`, data);
  }

  removeItem(key: string): void {
    this.storage?.removeItem(`${this.spaceName}-${key}`);
  }

  key(index: number): string {
    const val = this.storage?.key(index) || '';
    return val.replace(`${this.spaceName}-`, '');
  }

  clear(): void {
    this.storage?.clear();
  }

  get length(): number {
    return this.storage?.length || 0;
  }
}

export function createStorage(): Storage {
  return new AppLocalStorage('questra');
}
